import axios from 'axios';

const isFileLike = (value) => value instanceof File || value instanceof Blob;

const normalizeFormDataValue = (value) => {
  if (value instanceof Date) {
    return value.toISOString();
  }

  return value;
};

const buildSuppliersPayload = (payload = {}) => {
  if (payload instanceof FormData) {
    return payload;
  }

  if (!isFileLike(payload?.logo)) {
    return payload;
  }

  const formData = new FormData();

  Object.keys(payload || {}).forEach((key) => {
    const value = payload[key];

    if (value === undefined || value === null) {
      return;
    }

    formData.append(key, normalizeFormDataValue(value));
  });

  return formData;
};

export default {
  index: (params = {}, config = {}) => axios.get('suppliers', { params, ...config }),
  metrics: (params = {}, config = {}) => axios.get('suppliers/metrics', { params, ...config }),
  importSections: (config = {}) => axios.get('suppliers/imports/sections', config),
  importTemplate: (sectionKey, config = {}) => axios.get(`suppliers/imports/template/${sectionKey}`, {
    responseType: 'blob',
    ...config,
  }),
  importValidate: (payload, config = {}) => axios.post('suppliers/imports/validate', payload, config),
  importExecute: (batchId, payload = {}, config = {}) => axios.post(`suppliers/imports/${batchId}/execute`, payload, config),
  exportColumns: (config = {}) => axios.get('suppliers/exports/columns', config),
  exportFormats: (config = {}) => axios.get('suppliers/exports/formats', config),
  exportFormatStore: (payload = {}, config = {}) => axios.post('suppliers/exports/formats', payload, config),
  exportFormatUpdate: (formatId, payload = {}, config = {}) => axios.put(`suppliers/exports/formats/${formatId}`, payload, config),
  exportFormatDelete: (formatId, config = {}) => axios.delete(`suppliers/exports/formats/${formatId}`, config),
  exportExcel: (payload = {}, config = {}) => axios.post('suppliers/exports/excel', payload, {
    responseType: 'blob',
    ...config,
  }),
  selectors: (params = {}, config = {}) => axios.get('suppliers/selectors', { params, ...config }),
  show: (supplierId) => axios.get(`suppliers/${supplierId}`),
  mergeSummary: (supplierId, config = {}) => axios.get(`suppliers/${supplierId}/merge-summary`, config),
  detailOverview: (supplierId, config = {}) => axios.get(`suppliers/${supplierId}/overview`, config),
  activity: (supplierId, params = {}, config = {}) => axios.get(`suppliers/${supplierId}/activity`, { params, ...config }),
  store: (payload = {}, config = {}) => {
    const requestPayload = buildSuppliersPayload(payload);
    return axios.post('suppliers', requestPayload, config);
  },
  update: (supplierId, payload = {}, config = {}) => {
    const requestPayload = buildSuppliersPayload(payload);

    if (requestPayload instanceof FormData) {
      requestPayload.set('_method', 'PUT');
      return axios.post(`suppliers/${supplierId}`, requestPayload, config);
    }

    return axios.put(`suppliers/${supplierId}`, requestPayload, config);
  },
  merge: (supplierId, payload = {}, config = {}) => axios.put(`suppliers/${supplierId}/merge`, payload, config),
  toggleStatus: (supplierId, payload = {}) => axios.put(`suppliers/${supplierId}/status`, payload),
  syncFinancials: (payload = {}, config = {}) => axios.post('suppliers/sync-financials', payload, config),
  delete: (supplierId) => axios.delete(`suppliers/${supplierId}`),
  skillsStore: (supplierId, payload = {}) => axios.post(`suppliers/${supplierId}/skills`, payload),
  personsIndex: (supplierId) => axios.get(`suppliers/${supplierId}/persons`),
  personsStore: (supplierId, payload = {}) => axios.post(`suppliers/${supplierId}/persons`, payload),
  personsUpdate: (supplierId, personId, payload = {}) => axios.put(`suppliers/${supplierId}/persons/${personId}`, payload),
  personsDelete: (supplierId, personId) => axios.delete(`suppliers/${supplierId}/persons/${personId}`),
  personsSetDefault: (supplierId, personId) => axios.put(`suppliers/${supplierId}/persons/${personId}/default`),
  contributorsIndex: (supplierId, config = {}) => axios.get(`suppliers/${supplierId}/contributors`, config),
  contributorsStore: (supplierId, payload = {}) => axios.post(`suppliers/${supplierId}/contributors`, payload),
  contributorsUpdate: (supplierId, contributorId, payload = {}) => axios.put(`suppliers/${supplierId}/contributors/${contributorId}`, payload),
  contributorsDelete: (supplierId, contributorId) => axios.delete(`suppliers/${supplierId}/contributors/${contributorId}`),
  recordsIndex: (supplierId, params = {}, config = {}) => axios.get(`suppliers/${supplierId}/records`, { params, ...config }),
  recordsStore: (supplierId, payload = {}) => axios.post(`suppliers/${supplierId}/records`, payload),
  recordsUpdate: (supplierId, recordId, payload = {}) => axios.put(`suppliers/${supplierId}/records/${recordId}`, payload),
  recordsDelete: (supplierId, recordId) => axios.delete(`suppliers/${supplierId}/records/${recordId}`),
  documentsIndex: (supplierId, params = {}, config = {}) => axios.get(`suppliers/${supplierId}/documents`, { params, ...config }),
  documentsStore: (supplierId, payload = {}, config = {}) => axios.post(`suppliers/${supplierId}/documents`, payload, config),
  documentsUpdate: (supplierId, documentId, payload = {}, config = {}) => axios.put(`suppliers/${supplierId}/documents/${documentId}`, payload, config),
  documentsDelete: (supplierId, documentId) => axios.delete(`suppliers/${supplierId}/documents/${documentId}`),
  documentsDownloadAll: (supplierId, params = {}, config = {}) => axios.get(
    `suppliers/${supplierId}/documents/download-all`,
    {
      params,
      responseType: 'blob',
      ...config,
    }
  ),
  documentsDownloadLegalFile: (supplierId, params = {}, config = {}) => axios.get(
    `suppliers/${supplierId}/documents/download-legal-file`,
    {
      params,
      responseType: 'blob',
      ...config,
    }
  ),
};
